import "./LayoutWizardAdvertisement.scss";
import LayoutWizardServiceproviderDialog from "@/components/LayoutWizard/LayoutWizardServiceproviderDialog/LayoutWizardServiceproviderDialog.vue";
import { forceFileDownload, getTokenHeader } from "@/helpers/commonHelper";
import * as layoutWizardHelper from "@/helpers/layoutWizardHelper";
import * as XLSX from "xlsx";
import * as _ from "lodash";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "LayoutWizardAdvertisement",
  components: { LayoutWizardServiceproviderDialog },
  data() {
    return {
      headers: [
        {
          text: "Leistungsträger",
          align: "start",
          value: "title"
        },
        { text: "Saison", value: "season_id" },
        { text: "Vorschau", value: "pdf_file" },
        { text: "Status", value: "status" },
        { text: "interner Status", value: "internal_status" },
        { text: "Format", value: "format" },
        { text: "Preis", value: "price" },
        { text: "Letzte aktivität", value: "changed" },
        { text: "Aktionen", value: "actions", sortable: false }
      ],
      seasons: {},
      itemsPerPage: 10,
      seasonsKey: {},
      currentSeason: "",
      formats: [],
      search: "",
      editDialog: false,
      editedItem: {
        title: "",
        print_approval: false
      },
      defaultItem: {},
      advertisements: [],
      internalStatusItem: {},
      loading: true,
      loadingOverlay: false,
      options: {},
      total: 0,
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      dialog: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      config: {},
      page: 1,
      pageCount: 0,
      filter: {
        internalStatus: null,
        approved: "",
        format: null
      }
    };
  },
  watch: {
    options() {
      this.loadAdvertisements();
    },
    search(val) {
      if (val.length >= 3) this.loadAdvertisements();
      if (val === "") this.loadAdvertisements();
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  async mounted() {
    const itemsPerPage = this.itemsPerPage;
    this.options.itemsPerPage = itemsPerPage;
    await this.loadConfig();
    await this.loadSeasons();
    await this.loadFormats();
    this.loadAdvertisements();
  },
  methods: {
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    setToLocalStorage(value) {
      localStorage.setItem("itemsPerPage", value);
    },
    ...layoutWizardHelper,
    getAdvertisementsSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      return {
        principal_id: this.currentPrincipal,
        season_id: this.currentSeason,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy?.[0],
        direction: sortDesc?.[0] ? "desc" : "asc",
        with_login_tokens: 1,
        query: this.search,
        approved: this.filter.approved,
        format: this.filter.format,
        internal_status: this.filter.internalStatus
      };
    },
    async loadAdvertisements() {
      if (!this.currentSeason) {
        return;
      }
      this.loading = true;
      const headers = getTokenHeader();
      const params = this.getAdvertisementsSearchParams();
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "advertisements/",
          {
            headers,
            params
          }
        );
        this.advertisements = response.data;
        let count = response?.headers?.["x-count"];
        if (isNaN(count)) {
          console.error("no number in x-count");
        }
        this.total = parseInt(count);
      } catch (error) {
        this.createError(error);
      }
      this.loading = false;
    },
    resetFilter() {
      this.filter = {
        internalStatus: null,
        approved: "",
        format: null
      };
      this.loadAdvertisements();
    },
    async revokeStatusItem(item) {
      if (!item.print_approval) {
        return;
      }
      item.loading = true;
      const headers = getTokenHeader();
      try {
        await axios.put(
          `${env.assistent_api_client_url}advertisements/reset/${item._id}`,
          null,
          { headers }
        );
        item.print_approval = false;
      } catch (err) {
        this.createError(err);
      }
      item.loading = false;
    },
    async updateInternalStatus(item, sendItem) {
      item.loading = true;
      try {
        const headers = getTokenHeader();
        const res = await axios.put(
          `${env.assistent_api_client_url}advertisements/update_internal_status/${item._id}`,
          { internal_status: sendItem.internal_status },
          { headers }
        );
        item.internal_status = res.data.internal_status;
      } catch (err) {
        this.createError(err);
      }
      item.loading = false;
    },
    pdfPath(id) {
      return env.assistent_api_client_url + "files/" + id;
    },
    istatusOpen(item) {
      this.internalStatusItem = Object.assign({}, item);
    },
    async downloadAdZip() {
      this.loadingOverlay = true;
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        const response = await axios.get(
          env.assistent_api_client_url + "advertisements/export",
          {
            headers,
            params,
            responseType: "arraybuffer"
          }
        );
        forceFileDownload(response.data, "anzeigen.zip");
      } catch (error) {
        this.createError(error);
      }
      this.loadingOverlay = false;
    },
    async downloadAdXML() {
      this.loadingOverlay = true;
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        const response = await axios.get(
          env.assistent_api_client_url + "advertisements/export_print_xml",
          {
            headers,
            params,
            responseType: "arraybuffer"
          }
        );
        forceFileDownload(response.data, "anzeigen.xml");
      } catch (error) {
        this.createError(error);
      }
      this.loadingOverlay = false;
    },
    async getAdFullList() {
      const params = this.getAdvertisementsSearchParams();
      params["limit"] = 9999;
      params["offset"] = 0;

      let advertisements = [];
      const headers = getTokenHeader();
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "advertisements/",
          {
            headers,
            params
          }
        );
        advertisements = response.data;
      } catch (error) {
        this.createError(error);
      }

      return advertisements;
    },
    async getServiceproviders() {
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal,
          offset: 0,
          limit: 9999
        };
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/",
          {
            headers,
            params
          }
        );
        return response.data;
      } catch (error) {
        this.createError(error);
      }
    },

    // download list
    async downloadAdXslx() {
      this.loadingOverlay = true;
      const [advertisements, spList] = await Promise.all([
        this.getAdFullList(),
        this.getServiceproviders()
      ]);

      const sp = [];
      const spExternalIds = [];
      spList.forEach(item => {
        sp[item._id] = item.title;
        spExternalIds[item._id] = item.tomas_id;
      });

      // add title line
      const data = [
        [
          "Name",
          "Saison",
          "Leistungsträger",
          "Externe Id",
          "Straße",
          "PLZ",
          "Ort",
          "Kontaktperson",
          "Telefon",
          "Fax",
          "E-Mail",
          "Format",
          "Preis",
          "Druckfreigabe",
          "erstellt",
          "letzte Änderung"
        ]
      ];

      for (const ad of advertisements) {
        data.push([
          ad.title,
          this.seasonsKey?.[ad.season_id]
            ? this.seasonsKey[ad.season_id].title
            : "?",
          sp?.[ad.service_provider_id] ? sp[ad.service_provider_id] : "?",
          spExternalIds[ad.service_provider_id]
            ? spExternalIds[ad.service_provider_id]
            : "?",
          ad?.address?.street || "---",
          ad?.address?.zip || "---",
          ad?.address?.city || "---",
          ad?.address?.contact_person || "---",
          ad?.address?.phone || "---",
          ad?.address?.fax || "---",
          ad?.address?.email || "---",
          ad?.format || "",
          ad?.price || "",
          ad?.print_approval ? "JA" : "NEIN",
          ad?.created ? ad.created.toString().dateFormat() : "",
          ad?.changed ? ad.changed.toString().dateFormat() : ""
        ]);
      }

      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Anzeigen");
      XLSX.writeFile(workbook, "anzeigen.xlsx");
      this.loadingOverlay = false;
    },

    // download ad list configuration: config.export_config.customAdList
    async downloadCustomAdXslx() {
      this.loadingOverlay = true;
      const advertisements = await this.getAdFullList();

      const customAdFilename =
        this?.config?.export_config["customAdFilename"] ||
        "anzeigen-liste.xlsx";

      const customAdList = this?.config?.export_config["customAdList"] || false;

      if (!customAdList) {
        this.snackMessage("no customAdList-config!", "#c55c52");
        this.loadingOverlay = false;
        return;
      }

      const headArr = [];

      for (const k in customAdList) {
        // TODO: hasOwnProperty Check
        headArr.push(k);
      }
      // add title line
      const data = [headArr];

      for (const advertisement of advertisements) {
        const lineArr = [];
        for (const k in customAdList) {
          lineArr.push(
            // get deep-property-value https://lodash.com/docs#get
            // f.e. customAdList[k] == address.street
            // TODO: hasOwnProperty Check
            _.get(advertisement, customAdList[k], "-")
          );
        }
        data.push(lineArr);
      }

      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Anzeigen");
      XLSX.writeFile(workbook, customAdFilename);
      this.loadingOverlay = false;
    }
  }
};
